import{ FC } from 'react';
import { useFelaEnhanced } from 'hooks';
import { Tag as AntdTag } from 'antd';
import type { TagProps } from 'antd/es/tag';

import * as felaRules from './SupportProgressTag.styles';

const SupportProgressTag: FC<TagProps> = ({ children, ...rest }) => {
    const { styles } = useFelaEnhanced(felaRules);

    return (
        <AntdTag className={styles.tag} {...rest}>
            {children}
        </AntdTag>
    );
};

export default SupportProgressTag;
